// @generated — run pnpm icons:build to regenerate
export { HomeIcon } from './HomeIcon'
export { JourneysIcon } from './JourneysIcon'
export { MissionsIcon } from './MissionsIcon'
export { QuizzesIcon } from './QuizzesIcon'
export { PrizesIcon } from './PrizesIcon'
export { ShopIcon } from './ShopIcon'
export { SocialIcon } from './SocialIcon'
export { ScheduleIcon } from './ScheduleIcon'
export { LibraryIcon } from './LibraryIcon'
export { PartnersIcon } from './PartnersIcon'
export { SupportIcon } from './SupportIcon'
export { ModulesIcon } from './ModulesIcon'
export { BackpackIcon } from './BackpackIcon'
export { CellphoneIcon } from './CellphoneIcon'
export { FileIcon } from './FileIcon'
export { FolderIcon } from './FolderIcon'
export { HandshakeIcon } from './HandshakeIcon'

import type { ComponentType, SVGProps } from 'react'
import type { EvnttzIconName } from '../types'
import { HomeIcon } from './HomeIcon'
import { JourneysIcon } from './JourneysIcon'
import { MissionsIcon } from './MissionsIcon'
import { QuizzesIcon } from './QuizzesIcon'
import { PrizesIcon } from './PrizesIcon'
import { ShopIcon } from './ShopIcon'
import { SocialIcon } from './SocialIcon'
import { ScheduleIcon } from './ScheduleIcon'
import { LibraryIcon } from './LibraryIcon'
import { PartnersIcon } from './PartnersIcon'
import { SupportIcon } from './SupportIcon'
import { ModulesIcon } from './ModulesIcon'
import { BackpackIcon } from './BackpackIcon'
import { CellphoneIcon } from './CellphoneIcon'
import { FileIcon } from './FileIcon'
import { FolderIcon } from './FolderIcon'
import { HandshakeIcon } from './HandshakeIcon'

export const EVNTTZ_ICON_COMPONENTS = {
  home: HomeIcon,
  journeys: JourneysIcon,
  missions: MissionsIcon,
  quizzes: QuizzesIcon,
  prizes: PrizesIcon,
  shop: ShopIcon,
  social: SocialIcon,
  schedule: ScheduleIcon,
  library: LibraryIcon,
  partners: PartnersIcon,
  support: SupportIcon,
  modules: ModulesIcon,
  backpack: BackpackIcon,
  cellphone: CellphoneIcon,
  file: FileIcon,
  folder: FolderIcon,
  handshake: HandshakeIcon,
} as const satisfies Record<EvnttzIconName, ComponentType<SVGProps<SVGSVGElement>>>
